import { faArrowRightFromBracket } from '@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket';
import useResponsive from 'ahooks/es/useResponsive';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import FontAwesomeIcon from '#/components/FontAwesomeIcon.tsx';
import LinkButton from '@/components/LinkButton.tsx';
import useFlag from '@/lib/hooks/useFlag.ts';

import TooltipHelper from '../TooltipHelper.tsx';

type Props = {
  eventId: string;
};
const JoinDealersWorldButton = ({ eventId }: Props) => {
  const { t } = useTranslation(['common', 'dealers', 'schedule']);
  const { lg } = useResponsive();

  const dealersWorldDelayed = useFlag('dealersDen.worldDelayed');

  return (
    <TooltipHelper
      id="join-dealers-world"
      title={
        dealersWorldDelayed
          ? t(
              // TODO: own key
              'schedule:view.dealers_soon',
            )
          : t('dealers:join.tooltip')
      }
      child={
        <LinkButton
          variant={dealersWorldDelayed ? 'secondary' : 'primary'}
          size={lg ? 'lg' : undefined}
          className={clsx('text-white mr-0', lg ? 'position-absolute' : 'd-block mb-4')}
          to="/explore/event/$id"
          params={{ id: eventId }}
          // TODO Refactor:
          style={{
            ...(lg && {
              top: '3rem',
              right: '1rem',
            }),
          }}
          disabled={dealersWorldDelayed}
        >
          {dealersWorldDelayed ? (
            t(
              // TODO: own key
              'schedule:view.dealers_soon',
            )
          ) : (
            <>
              <span className="me-2">{t('dealers:join')}</span>
              <FontAwesomeIcon icon={faArrowRightFromBracket} className="ms-3" />
            </>
          )}
        </LinkButton>
      }
    />
  );
};

export default JoinDealersWorldButton;
